<template>
    <div>
        <Navbar :appTitle="appTitle" />

        <van-cell-group style="margin-top: 15px;">
            <p class="label required FormTit"><span></span>生产物品</p>
            <van-field readonly :value="buildForm.goodsName" placeholder="请选择" @click="getCheckedGoods" />
            <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
            <p class="label required FormTit"><span></span>计划生产数</p>
            <van-field :value="buildForm.goodsNum" type="number" placeholder="请输入" @input="goodsNumInput" />
            <div class="bottomLine"></div>


            <div style="display: flex;justify-content: center;">
                <van-button style="margin: 20px 0px;width: 140px;" :loading="isLoading" type="info"
                    @click="calculate">计算</van-button>
            </div>
        </van-cell-group>

        <van-cell-group style="margin-top: 15px;">
            <div>
                <div style="font-size: 16px;font-weight: bold;margin-left: 20px;padding-top: 15px;">计算结果</div>
                <div v-if="calculateInfo && calculateInfo.processList" style="margin-left: 80px">
                    <div style="font-weight: bold; margin-top: 10px;font-size: 14px;">
                        总工时：{{ calculateInfo.workHours }}h, {{ calculateInfo.workDays }}天
                    </div>
                    <div style="font-weight: bold; margin-top: 10px; color: #f18f8e;font-size: 14px;">
                        瓶颈工序：
                        <span v-for="(item, index) in calculateInfo.bottleneckList" :key="index">
                            {{ item.processesName }}({{ item.workHours }}h, {{ item.workDays }}天)
                        </span>
                    </div>
                    <div class="timeCalculate">
                        <div :style="{ color: item.bottleneck === true ? '#f18f8e' : '' }"
                            v-for="(item, index) in calculateInfo.processList" style="width: 90%;font-size: 14px;"
                            :key="index">
                            {{ item.sort }}、{{ item.processesName }}：({{ item.workHours }}h, {{ item.workDays }}天)
                        </div>
                    </div>
                </div>
                <div v-else style="padding: 100px 0px;display: flex;justify-content: center;color: gray;">
                    请选择生产物品、输入生产数量进行计算！
                </div>
            </div>
        </van-cell-group>
    </div>
</template>


<script>
import Navbar from "@/components/navBar/navBar_right";
import { manHoursCalculation } from '@/api/mobile'
import { clearNoNum } from '@/utils/util'
export default {
    name: 'manHourCalculation',
    components: {
        Navbar
    },
    data() {
        return {
            appTitle: '工时测算',
            buildForm: {
                goodsNum: '',
                goodsName: '',
                goodsId: ''
            },
            isLoading: false,
            calculateInfo: {}
        }
    },
    mounted() {
        const query = this.$route.query;
        this.buildForm.goodsName = query.itemNames
        this.buildForm.goodsId = query.itemId
    },
    methods: {
        getCheckedGoods() {
            this.$router.replace({
                path: "/selectItems"
            });
        },
        goodsNumInput(value) {
            this.buildForm.goodsNum = clearNoNum(value);
        },
        async calculate() {
            if (!this.buildForm.goodsId) {
                this.$toast("请选择生产物品");
                return;
            }

            if (!this.buildForm.goodsNum) {
                this.$toast("请输入生产数量");
                return;
            }

            if (Number(this.buildForm.goodsNum) === 0) {
                this.$toast("生产数量不可等于0");
                return;
            }

            this.isLoading = true
            try {
                const { result } = await manHoursCalculation({
                    goodsNum: this.buildForm.goodsNum,
                    goodsId: this.buildForm.goodsId
                })
                if (result) {
                    this.calculateInfo = result
                }
                else {
                    this.$toast("该物品未配置工艺路线");
                }
            } catch (e) {
                this.$toast(e.message);
            }
            finally {
                this.isLoading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.required span::after {
    left: -20px;
    top: 3px;
}

.bottomLine {
    height: 0.01rem;
    background-color: #f0f0f0;
    margin: 0 0.16rem;
}

.timeCalculate {
    font-weight: bold;
    margin-top: 10px;
    display: flex;
    width: 100%;
    // flex-wrap: wrap;
    flex-direction: column;
    align-items: start;
    padding-bottom: 40px;
    // height: 180px;
}
</style>